<template>
    <div>
        <div style="margin-bottom: 5px;">
            <el-button @click="onInsert">新增設定</el-button>
        </div>
        <el-table :data="pagedData" :border="true" height="600px">
            <el-table-column
                    prop="month"
                    label="月份"
            ></el-table-column>
            <el-table-column
                    label="範圍"
            >
                <template #default="{row}">
                    {{types[row.type]}}
                </template>
            </el-table-column>
            <el-table-column
                    label="開放星期"
            >
                <template #default="{row}">
                    {{row.openWeekday
                    .map((w, idx) => ({wd: w, fmt: formatShortWeekdayFormat(idx)}))
                    .filter(w => w.wd)
                    .map(w => w.fmt)
                    .join(', ')}}
                </template>
            </el-table-column>
            <el-table-column label="抽籤場地設定(只作用於可抽籤的場地)">
                <el-table-column label="需要抽籤?">
                    <template #default="{row}">
                        {{row.drawAtNight ? '是' : '否'}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="申請公告日期"
                        prop="publishAt"
                ></el-table-column>
                <el-table-column
                        label="申請截止日期"
                        prop="dueAt"
                ></el-table-column>
                <el-table-column
                        label="抽籤時間"
                        prop="drawAt"
                ></el-table-column>

            </el-table-column>

            <el-table-column label="異動">
                <template #default="{row}">
                    <el-button @click="onUpdate(row.id)">
                        修改
                    </el-button>
                    <el-button type="danger" @click="onDelete(row.id)">
                        刪除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                style="margin-top: 10px;"
                background
                layout="total, prev, pager, next"
                :total="months.length"
                :page-size="pageSize"
                @current-change="page => pageChange(page, months)"
                :current-page.sync="currentPage"
        ></el-pagination>
        <el-dialog
                :visible.sync="show"
                :title="mode === 'insert' ? '新增' : '異動'"
                @opened="onOpened"
        >
            <el-form
                    ref="form"
                    :model="monthSetting"
                    :rules="rules"
                    label-width="150px"
            >
                <el-form-item prop="month" v-if="mode==='insert'" label="月份">
                    <el-select v-model="monthSetting.month" placeholder="請選擇月份">
                        <el-option
                                v-for="m in availableMonths"
                                :key="m"
                                :value="m"
                                :label="m"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="月份" v-else>
                    <el-input
                            v-model="monthSetting.month" readonly
                    ></el-input>
                </el-form-item>
                <el-form-item prop="monthRange" label="月份起迄">
                    <el-date-picker
                            type="daterange"
                            start-placeholder="請選擇月份開始日"
                            end-placeholder="請選擇月份結束日"
                            v-model="monthSetting.monthRange"
                            value-format="yyyy-MM-dd"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="範圍" prop="type">
                    <el-radio-group v-model="monthSetting.type">
                        <el-radio :label="2">全天</el-radio>
                        <el-radio :label="0">白天</el-radio>
                        <el-radio :label="1">晚上</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="開放的星期">
                    <el-checkbox
                            v-for="(w, idx) in weekdays"
                            :key="idx"
                            v-model="monthSetting.openWeekday[idx]"
                    >{{w}}</el-checkbox>
                </el-form-item>
                <el-divider>以下是夜間抽籤的設定</el-divider>
                <el-form-item prop="drawAtNight" label="需要抽籤?">
                    <el-checkbox
                            v-model="monthSetting.drawAtNight"
                    ></el-checkbox>
                </el-form-item>
                <div v-if="monthSetting.drawAtNight">
                    <el-form-item prop="publishRange" label="申請起訖">
                        <el-date-picker
                                type="datetimerange"
                                start-placeholder="請選擇申請開始時間"
                                end-placeholder="請選擇申請結束時間"
                                v-model="monthSetting.publishRange"
                                value-format="yyyy-MM-dd HH:mm:ss"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item prop="drawAt" label="抽籤時間">
                        <el-date-picker
                                type="datetime"
                                placeholder="請選擇抽籤時間"
                                v-model="monthSetting.drawAt"
                                value-format="yyyy-MM-dd HH:mm:ss"
                        ></el-date-picker>
                    </el-form-item>
                </div>
            </el-form>
            <template #footer>
                <el-button type="primary" @click="onSubmit">{{mode === 'insert' ? '新增' : '異動'}}</el-button>
                <el-button @click="show = false">取消</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {createNamespacedHelpers, mapState as mapRootState} from 'vuex';
    import moment from 'moment';
    const {mapState, mapActions} = createNamespacedHelpers('setting');
    import {MonthTypes} from '../../constants';
    import pagingMixin from '../../pagingMixin';
    const defaultMonthSetting = {
        id: 0,
        drawAt: '',
        drawAtNight: false,
        month: undefined,
        type: 2,
        notOpenInWeekend: false,
        publishRange:[],
        monthRange:[],
        openWeekday: Array(7).fill(true)
    };

    export default {
        name: 'MonthSetting',
        data: () => ({
            monthSetting: {...defaultMonthSetting},
            mode: 'insert',
            show: false
        }),
        mixins:[pagingMixin],
        computed: {
            ...mapState(['months']),
            ...mapRootState(['loading']),
            types() {
                return MonthTypes;
            },
            availableMonths() {
                //1~12
                const monthsInYear = [...new Array(12).keys()].map(k => k + 1);
                return monthsInYear.filter(m => !this.months.some(s => s.month === m));
            },
            weekdays(){
                const now = moment();
                return [...Array(7).keys()].map(w => moment(now).day(w).format('dddd'));
            },
            rules() {
                const baseRules = {
                    month: [
                        {required: true, message: '請選擇月份'}
                    ],
                    type: [
                        {required: true, message: '請選擇開放範圍'}
                    ],
                    monthRange: [
                        {required: true, message: '請選擇月份起迄'}
                    ]
                };
                if (this.monthSetting.drawAtNight) {
                    return {
                        ...baseRules,
                        drawAt: [
                            {required: true, message: '請選擇抽籤日期'}
                        ],
                        publishRange: [
                            {required: true, message: '請選擇申請起訖'}
                        ]
                    };
                }
                return baseRules;
            }
        },
        methods: {
            ...mapActions({
                insertMonth: 'insertMonthAction',
                updateMonth: 'updateMonthAction',
                deleteMonth: 'deleteMonthAction',
            }),
            formatShortWeekdayFormat(weekday){
                return moment().day(weekday).format('dd');
            },
            onInsert() {
                this.mode = 'insert';
                this.monthSetting = {...defaultMonthSetting};

                this.show = true;
            },
            onUpdate(id) {
                this.mode = 'update';
                this.show = true;
                this.monthSetting = {...(this.months.find(m => m.id === id) || {})};
            },
            async onDelete(id){
                try {
                    await this.$confirm('確定刪除嗎?',{
                        type: 'warning',
                    });
                    const{success} = await this.deleteMonth(id);
                    if(success){
                        this.$message({
                            type: 'success',
                            message: '刪除成功'
                        });
                    } else{
                        this.$message({
                            type: 'warning',
                            message: '刪除失敗，請重試一次'
                        });
                    }
                }catch (e) {
                    if(e !== 'cancel'){
                        this.$message({
                            type: 'error',
                            message: '發生錯誤，請重試一次!'
                        });
                    }
                }
            },
            onOpened() {
                this.$refs.form.clearValidate();
            },
            async onSubmit() {
                const {form} = this.$refs;
                form.validate(async (valid) => {
                    if(valid){
                        const [publishAt, dueAt] = this.monthSetting.publishRange;
                        const [fstDate, lstDate] = this.monthSetting.monthRange;
                        const params = {...this.monthSetting, publishAt, dueAt,
                            fstDate, lstDate};
                        if (this.mode === 'insert') {

                            const {success} = await this.insertMonth(params);
                            if (success) {
                                this.$message({
                                    message: '新增成功',
                                    type: 'success'
                                });
                                this.show = false;
                                this.monthSetting = {...defaultMonthSetting};
                            } else {
                                this.$message({
                                    message: '新增失敗，請重試一次',
                                    type: 'warning'
                                });
                            }
                        } else {
                            const {success} = await this.updateMonth(params);
                            if (success) {
                                this.$message({
                                    message: '異動成功',
                                    type: 'success'
                                });
                                this.show = false;
                            } else {
                                this.$message({
                                    message: '異動失敗，請重試一次',
                                    type: 'warning'
                                });
                            }
                        }
                    } else {
                        this.$message({
                            message: '您有欄位未輸入',
                            type: 'warning'
                        });
                    }
                });
            }
        },
        created() {
            this.pagedData = this.pageData(this.months, 1);
        },
        watch:{
            months(current){
                this.pagedData = this.pageData(this.months, 1);
            }
        }
    }
</script>

<style>

</style>